import type { ShopShiftAssignmentRow } from "@/modules/merchant/presentation/api/client";

export function assignmentStatusLabel(row: ShopShiftAssignmentRow): string {
  if (row.status === "canceled") return "ຍົກເລີກ";
  if (row.clockInAt && row.clockOutAt) return "ປິດກະແລ້ວ";
  if (row.clockInAt) return "ກຳລັງເປີດ";
  if (row.status === "confirmed") return "ຢືນຢັນ";
  return "ກຳນົດ";
}

export function assignmentStatusBadgeVariant(row: ShopShiftAssignmentRow) {
  if (row.status === "canceled") return "destructive" as const;
  if (row.clockInAt && row.clockOutAt) return "secondary" as const;
  if (row.clockInAt) return "success" as const;
  return "warning" as const;
}

export function assignmentStatusRowAccent(row: ShopShiftAssignmentRow): string {
  if (row.status === "canceled") {
    return "border-l-muted-foreground/40 bg-muted/10";
  }
  if (row.clockInAt && row.clockOutAt) {
    return "border-l-slate-400 bg-slate-500/[0.04] dark:border-l-slate-500";
  }
  if (row.clockInAt) {
    return "border-l-emerald-500 bg-emerald-500/[0.06] dark:border-l-emerald-400";
  }
  return "border-l-amber-500 bg-amber-500/[0.05] dark:border-l-amber-400";
}

export type ShiftWeekStats = {
  total: number;
  open: number;
  closed: number;
  scheduled: number;
  canceled: number;
};

export function computeShiftWeekStats(
  items: ShopShiftAssignmentRow[],
): ShiftWeekStats {
  let total = 0;
  let open = 0;
  let closed = 0;
  let scheduled = 0;
  let canceled = 0;

  for (const row of items) {
    if (row.status === "canceled") {
      canceled += 1;
      continue;
    }
    total += 1;
    if (row.clockInAt && row.clockOutAt) closed += 1;
    else if (row.clockInAt) open += 1;
    else scheduled += 1;
  }

  return { total, open, closed, scheduled, canceled };
}
